import { Typography } from "@mui/material";
import { GeneratorStatusThresholdBand } from "generated-graphql/graphql";

export function CalculationThreshold({
  status,
  bands,
}: {
  status: string | null | undefined;
  bands: readonly GeneratorStatusThresholdBand[];
}) {
  const band = bands.find((b) => b.status === status);
  if (!band) {
    return (
      <Typography variant="body2" color="text.secondary">
        Threshold unavailable
      </Typography>
    );
  }
  return (
    <>
      <Typography variant="body2">{band.range}</Typography>
      {band.condition && (
        <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
          {band.condition}
        </Typography>
      )}
    </>
  );
}
